export default __webpack_public_path__ + "static/media/banner1.132b1d5a.png";